import { render, staticRenderFns } from "./AlertDisplay.vue?vue&type=template&id=31aa188f&scoped=true&"
import script from "./AlertDisplay.vue?vue&type=script&lang=js&"
export * from "./AlertDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AlertDisplay.vue?vue&type=style&index=0&id=31aa188f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aa188f",
  null
  
)

export default component.exports